<script>
import Accordion from '@/components/Accordion/Main';
import AccordionItem from '@/components/Accordion/Item';

export default {
  props: {},
  components: {
    Accordion,
    AccordionItem,
  },
};
document.querySelector('#app').classList.add('overflow-hidden');
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <div class="flex flex-col lg:flex-row">
        <div class="w-full lg:w-2/3 xl:w-3/4 mr-5">
          <h2 class="title-h2 mb-6">Ответы на популярные вопросы</h2>
          <accordion>
            <accordion-item>
              <template #accordion-trigger>
                <p>
                  Чем Volkswagen Passat отличается от&nbsp;других подержанных
                  седанов?
                </p>
              </template>

              <template #accordion-content>
                <p>
                  Фольксваген Passat сочетает в&nbsp;себе премиальное качество,
                  комфорт и&nbsp;передовые технологии.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p>
                  Как проверить техническое состояние подержанного автомобиля?
                </p>
              </template>

              <template #accordion-content>
                <p>
                  При покупке в&nbsp;&laquo;Прагматике&raquo; вы&nbsp;получаете
                  автомобиль с&nbsp;проведенной диагностикой и&nbsp;полным
                  отчетом о&nbsp;состоянии.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p>
                  Можно&nbsp;ли купить Volkswagen Passat с&nbsp;пробегом
                  в&nbsp;кредит?
                </p>
              </template>

              <template #accordion-content>
                <p>
                  Да, мы&nbsp;предлагаем выгодные кредитные программы
                  с&nbsp;минимальной процентной ставкой.
                </p>
              </template>
            </accordion-item>
          </accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
p {
  color: #81869a;
}
</style>
